import { PopperModifierOverrides } from '@blueprintjs/core'

export const POPPER_MODIFIER_NO_ARROW: PopperModifierOverrides = { arrow: { enabled: false } }
